export default __webpack_public_path__ + "static/media/icon_v2_mail.82fa50d2.svg";